export const c_droppable_m_dragging_after_BackgroundColor = {
  "name": "--pf-c-droppable--m-dragging--after--BackgroundColor",
  "value": "rgba(255, 255, 255, 0.6)",
  "var": "var(--pf-c-droppable--m-dragging--after--BackgroundColor)"
};
export default c_droppable_m_dragging_after_BackgroundColor;